import i18n from 'i18n';
import { IField } from 'modules/core/types/common';
import {
  requiredValidator,
  validateCreditScore,
  validateMinRequiredValue,
  validateMinRequiredValueForDropdown,
} from 'modules/core/validators';
import { PROBABILITY_ESTIMATOR_FIELDS } from 'modules/ProbabilityEstimator/probabilityEstimator.const';
import {
  CalculatorAdornment,
  DollarAdornment,
  HighlightedInput,
  Input,
  SearchAdornment,
} from 'modules/core/components';

import { LenderTierDropdown } from '../CustomDropdowns/LenderTierDropdown';
import { DealerDropdown } from '../CustomDropdowns/DealerDropdown';

export const TIER_NAME = 'tier';

export const ROUTE_ONE_SEARCH_FIELD_NAME = 'routeOneSearch';
export const ROUTE_ONE_DEALER_FIELD_NAME = 'routeOneDealer';
export const ROUTE_ONE_DEALER_ID_FIELD_NAME = 'routeOneDealerId';

export const ROUTE_ONE_FILEDS_NAMES = [
  ROUTE_ONE_SEARCH_FIELD_NAME,
  ROUTE_ONE_DEALER_FIELD_NAME,
  ROUTE_ONE_DEALER_ID_FIELD_NAME,
];

export const REHASH_CALCULATOR_FIELDS: IField[] = [
  {
    name: TIER_NAME,
    component: LenderTierDropdown,
    label: i18n.t('components.lender.tier'),
    isVerticalAlign: true,
    controlProps: {
      required: true,
      validate: validateCreditScore,
    },
  },
  {
    name: PROBABILITY_ESTIMATOR_FIELDS.GROSS_MONTHLY_INCOME,
    component: HighlightedInput,
    label: i18n.t('components.consumerInformation.monthlyIncome'),
    isVerticalAlign: true,
    controlProps: {
      textStyle: 'bold',
      textPosition: 'start',
      startAdornment: <DollarAdornment />,
      endAdornment: <CalculatorAdornment />,
      decimalScale: 0,
      placeholder: i18n.t('components.input.placeholders.integer'),
      required: true,
      rules: requiredValidator,
      validate: validateMinRequiredValue,
    },
  },
  {
    name: PROBABILITY_ESTIMATOR_FIELDS.NET_DOWN_PAYMENT,
    component: Input,
    label: i18n.t('components.consumerInformation.totalCashAndTrade'),
    isVerticalAlign: true,
    controlProps: {
      textStyle: 'bold',
      textPosition: 'start',
      startAdornment: <DollarAdornment />,
      endAdornment: <CalculatorAdornment />,
      disabled: false,
      decimalScale: 0,
      allowNegative: true,
      readonly: true,
      hideInitZeroValue: true,
      placeholder: i18n.t('components.input.placeholders.integer'),
    },
  },
];

export const ROUTE_ONE_SEARCH_FIELD: IField = {
  name: ROUTE_ONE_SEARCH_FIELD_NAME,
  component: Input,
  label: i18n.t('components.lender.routeOne.searchField.label'),
  isVerticalAlign: true,
  controlProps: {
    textStyle: 'bold',
    textPosition: 'start',
    valueAsNumber: false,
    maxLength: 21,
    endAdornment: <SearchAdornment />,
    required: true,
    rules: requiredValidator,
    validate: validateMinRequiredValue,
    placeholderWithoutAsterisk: true,
    placeholder: i18n.t('components.lender.routeOne.searchField.placeholder'),
  },
};

export const ROUTE_ONE_DEALER_FIELD: IField = {
  name: ROUTE_ONE_DEALER_FIELD_NAME,
  component: DealerDropdown,
  label: i18n.t('components.lender.routeOne.dealerField.label'),
  isVerticalAlign: true,
  controlProps: {
    required: true,
    rules: requiredValidator,
    validate: validateMinRequiredValueForDropdown,
    placeholder: i18n.t('components.lender.routeOne.searchField.placeholder'),
  },
};

export const ROUTE_ONE_DEALER_ID_FIELD: IField = {
  name: ROUTE_ONE_DEALER_ID_FIELD_NAME,
  component: Input,
  label: i18n.t('components.lender.routeOne.dealerIdField'),
  isVerticalAlign: true,
  controlProps: {
    valueAsNumber: false,
    required: true,
    endAdornment: <SearchAdornment />,
    rules: requiredValidator,
    maxLength: 5,
    placeholder: i18n.t('components.lender.routeOne.dealerIdField'),
  },
};
